import { FC, useEffect, useRef, useState } from 'react';
import JsBarcode from 'jsbarcode';

interface BarcodeProps {
  value: string;
  className?: string;
}

/**
 * 一維條碼(CODE128),給店員用 POS 掃描器刷券碼用(PG-178 全家咖啡券)。
 * 產生失敗(碼裡有 CODE128 不支援的字元)就不畫,券碼文字仍由呼叫端顯示,民眾還能念給店員。
 */
const Barcode: FC<BarcodeProps> = ({ value, className }) => {
  const svgRef = useRef<SVGSVGElement>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg || !value) {
      return;
    }
    try {
      JsBarcode(svg, value, {
        format: 'CODE128',
        width: 2,
        height: 90,
        margin: 16, // 左右留白(quiet zone)不夠,掃描器會讀不到
        displayValue: false,
        background: '#ffffff',
        lineColor: '#000000',
      });
      // JsBarcode 只寫死 px 寬高,補上 viewBox 才能用 CSS 縮放到螢幕寬
      const w = svg.getAttribute('width');
      const h = svg.getAttribute('height');
      if (w && h) {
        svg.setAttribute('viewBox', `0 0 ${parseFloat(w)} ${parseFloat(h)}`);
        svg.removeAttribute('width');
        svg.removeAttribute('height');
      }
      setFailed(false);
    } catch (e) {
      console.error('[Barcode] 條碼產生失敗', value, e);
      setFailed(true);
    }
  }, [value]);

  if (!value || failed) {
    return null;
  }
  return <svg ref={svgRef} className={className} role="img" aria-label={`條碼 ${value}`} />;
};

export default Barcode;
